import {Component, HostListener, OnInit} from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  onMobile = false;
  screenWidth: number = window.innerWidth;

  ngOnInit(): void {
    document.addEventListener("click", function(e: MouseEvent) {
      const targetElement = e.target as Element;
      if (targetElement.tagName === "A" && !targetElement.hasAttribute("target")) {
        console.log('opening a link in new tab!')
        targetElement.setAttribute("target", "_blank");
      }
    });

    if (window.innerWidth < 1279) {
      this.onMobile = true;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.screenWidth = window.innerWidth;
    if (window.innerWidth < 1279) {
      this.onMobile = true;
    } else {
      this.onMobile = false;
    }
  }
}
